export { default as CarrierList } from './CarrierList';
export { default as CarrierEdit } from './CarrierEdit';



// WEBPACK FOOTER //
// ./src/modules/carrier/pages/index.js